<template>
  <div class="product_box cart_product_box flex-r-c-c">
    <div class="pro_info flex-r-s-c">
      <van-image width="2.56rem" height="1.92rem" :src="myinfo.iconUrl" />
      <div class="cart_pro_info">
        <div class="pro_name van-multi-ellipsis--l2">{{ myinfo.name }}</div>
        <div class="pro_brand_model van-ellipsis">{{ myinfo.brand }} | {{ myinfo.specifications }}</div>
        <!-- <div class="pro_tags">1</div> -->
        <div class="pro_bottom flex-r-sb-c">
          <div class="pro_money">￥<span
            style="font-size: 0.49rem;"
          >{{ myinfo.showPrice === 0? myinfo.price :'详询客服' }}</span></div>
          <div class="pro_num_change">
            <van-stepper v-model="myinfo.priceNum" :step="myinfo.multiplyQuantity === 1 ? myinfo.minQuantity : 1" :min="myinfo.minQuantity" integer input-width="1rem"
                         button-size="0.5rem" @change="changeNum"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { shoppingCart_update } from '@/api/cart'
export default {
  props: {
    info: { type: Object, default: () => { } }
  },
  data() {
    return {
      myinfo: this.info
    }
  },
  methods: {
    // 修改数量
    changeNum(val) {
      const parms = {
        priceNum: val,
        productId: this.info.productId
      }
      console.log(parms)
      shoppingCart_update(parms).then(res => {
        this.$set(this.info, 'price', res.data.price)
        this.$emit('changeNum', res.data)
      })
    }
  }
}
</script>
